import type { SVGProps } from 'react';
const SvgSearchStreamlineCore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Search Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M8.59 16.518A7.929 7.929 0 1 0 8.59.66a7.929 7.929 0 0 0 0 15.857M14.192 14.192l3.647 3.648" />
    </g>
  </svg>
);
export default SvgSearchStreamlineCore;
